/* MD Promo Bar — countdown + flip no digito que mudou. Vanilla, defer, zero deps. */
(function () {
  if (typeof window === 'undefined' || typeof window.customElements === 'undefined') return;
  if (window.customElements.get('md-promo-bar')) return;

  var FLIP_CLASS = 'md-promo__flip--active';

  function pad2(n) {
    var s = String(n);
    return s.length < 2 ? '0' + s : s;
  }

  function getZoneParts(utcMs, zone) {
    try {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: zone,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      var parts = fmt.formatToParts(new Date(utcMs));
      var out = { year: 0, month: 1, day: 1, hour: 0, minute: 0, second: 0 };
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        if (p.type === 'year') out.year = Number(p.value);
        else if (p.type === 'month') out.month = Number(p.value);
        else if (p.type === 'day') out.day = Number(p.value);
        else if (p.type === 'hour') out.hour = Number(p.value) % 24;
        else if (p.type === 'minute') out.minute = Number(p.value);
        else if (p.type === 'second') out.second = Number(p.value);
      }
      return out;
    } catch (e) {
      var d = new Date(utcMs);
      return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds()
      };
    }
  }

  function zoneOffsetMs(utcMs, zone) {
    var parts = getZoneParts(utcMs, zone);
    var asUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
    return asUtc - utcMs;
  }

  function endOfTodayInZone(zone) {
    var now = Date.now();
    var parts = getZoneParts(now, zone);
    var dayStartUtc = Date.UTC(parts.year, parts.month - 1, parts.day, 0, 0, 0);
    var offset = zoneOffsetMs(dayStartUtc, zone);
    // 23:59:59.999 local -> UTC
    return dayStartUtc - offset + (24 * 3600 * 1000) - 1;
  }

  function parseEndDate(str, zone) {
    if (!str) return null;
    var trimmed = String(str).trim();
    if (!trimmed) return null;

    // ISO with explicit timezone (Z or +HH:MM) — use native parser directly.
    if (/Z$|[+-]\d{2}:?\d{2}$/.test(trimmed)) {
      var isoMs = Date.parse(trimmed);
      return isNaN(isoMs) ? null : isoMs;
    }

    var m = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?$/);
    if (!m) {
      var fallback = Date.parse(trimmed);
      return isNaN(fallback) ? null : fallback;
    }
    var y = Number(m[1]);
    var mo = Number(m[2]);
    var d = Number(m[3]);
    var h = m[4] ? Number(m[4]) : 23;
    var mi = m[5] ? Number(m[5]) : 59;
    var s = m[6] ? Number(m[6]) : 0;

    var guess = Date.UTC(y, mo - 1, d, h, mi, s);
    var offset = zoneOffsetMs(guess, zone);
    return guess - offset;
  }

  class MdPromoBar extends HTMLElement {
    connectedCallback() {
      this.hTens = this.querySelector('[data-h-tens]');
      this.hOnes = this.querySelector('[data-h-ones]');
      this.mTens = this.querySelector('[data-m-tens]');
      this.mOnes = this.querySelector('[data-m-ones]');
      this.sTens = this.querySelector('[data-s-tens]');
      this.sOnes = this.querySelector('[data-s-ones]');

      // Nothing to tick if the countdown block is absent.
      if (!this.sOnes) return;

      this.zone = this.dataset.timezone || 'America/New_York';
      var endAttr = this.dataset.end;
      var parsed = parseEndDate(endAttr, this.zone);
      if (parsed) {
        this.endTarget = parsed;
        this.autoRotate = false;
      } else {
        this.endTarget = endOfTodayInZone(this.zone);
        this.autoRotate = true;
      }

      this.boundTick = this.tick.bind(this);
      this.tick();
      this.timer = window.setInterval(this.boundTick, 1000);
    }

    disconnectedCallback() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    tick() {
      var now = Date.now();
      var remainingMs = this.endTarget - now;
      if (remainingMs <= 0) {
        if (this.autoRotate) {
          this.endTarget = endOfTodayInZone(this.zone);
          remainingMs = Math.max(0, this.endTarget - now);
        } else {
          remainingMs = 0;
        }
      }
      var remaining = Math.floor(remainingMs / 1000);
      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;
      if (h > 99) h = 99;

      var hs = pad2(h);
      var ms = pad2(m);
      var ss = pad2(s);

      this.setDigit(this.hTens, hs.charAt(0));
      this.setDigit(this.hOnes, hs.charAt(1));
      this.setDigit(this.mTens, ms.charAt(0));
      this.setDigit(this.mOnes, ms.charAt(1));
      this.setDigit(this.sTens, ss.charAt(0));
      this.setDigit(this.sOnes, ss.charAt(1));
    }

    setDigit(el, char) {
      if (!el) return;
      if (el.textContent === char) return;
      el.textContent = char;
      this.flip(el);
    }

    flip(el) {
      if (!el) return;
      el.classList.remove(FLIP_CLASS);
      // Force reflow so the keyframe restarts even on consecutive ticks.
      void el.offsetWidth;
      el.classList.add(FLIP_CLASS);
    }
  }

  window.customElements.define('md-promo-bar', MdPromoBar);
})();
